import {useCallback} from 'react';
import {Navigate, Outlet} from 'react-router-dom';

import constants from '@/config/constant';
import {useAppDispatch, useAppSelector} from '@/store/store-hooks';
import {endSession} from './session-actions';
import {useIdleTimeout} from './use-idle-timeout';

/**
 * Route guard for the direct-auth (browser-signed) mode. With the feature flag
 * off it is a pass-through, so the gateway-signed app is unaffected. With the
 * flag on it redirects to /login until the session is unlocked, and once
 * unlocked it arms an inactivity timeout that clears the in-memory key.
 * See this.i wqz7k3mnbp.
 */
export default function SessionGuard() {
  const enabled = constants.DIRECT_AUTH_ENABLED;
  const unlocked = useAppSelector(s => s.authSession.unlocked);
  const dispatch = useAppDispatch();

  const onIdle = useCallback(() => endSession(dispatch), [dispatch]);
  useIdleTimeout(
    enabled && unlocked,
    constants.DIRECT_AUTH_IDLE_TIMEOUT_MIN * 60_000,
    onIdle,
  );

  if (enabled && !unlocked) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
